export const TKeyProjects = {
  PROJECT: "PROJECT",
  PROJECT_SITE_VISIT: "PROJECT_SITE_VISIT",
  PROJECT_NAME: "PROJECT_NAME",
  PROJECT_NAME_PLACEHOLDER: "PROJECT_NAME_PLACEHOLDER",
  PROJECT_DESCRIPTION: "PROJECT_DESCRIPTION",
  PROJECT_DESCRIPTION_PLACEHOLDER: "PROJECT_DESCRIPTION_PLACEHOLDER",
  PROJECT_TAB_OVERVIEW: "PROJECT_TAB_OVERVIEW",
  PROJECT_TAB_EXTERNAL_MEMBERS: "PROJECT_TAB_EXTERNAL_MEMBERS",
  PROJECT_MEMBERS_EMPTY: "PROJECT_MEMBERS_EMPTY",
  PROJECT_OFFERS_EMPTY: "PROJECT_OFFERS_EMPTY",
  PROJECT_OFFER_ADD: "PROJECT_OFFER_ADD",
  PROJECT_LINK_LABEL: "PROJECT_LINK_LABEL",
  PROJECT_LINK_PLACEHOLDER: "PROJECT_LINK_PLACEHOLDER",
  PROJECT_ADD: "PROJECT_ADD",
  PROJECT_DELETE: "PROJECT_DELETE",
  PROJECT_DELETE_WARNING: "PROJECT_DELETE_WARNING",
  PROJECT_DELETE_CONFIRM: "PROJECT_DELETE_CONFIRM",
  PROJECT_DELETE_CONFIRM_PREFIX: "PROJECT_DELETE_CONFIRM_PREFIX",
  PROJECT_DELETE_CONFIRM_SUFFIX: "PROJECT_DELETE_CONFIRM_SUFFIX",
} as const;
